<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">

        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">{{ $t("sidebar.visitors") }}</h3>
            </div>
            <div class="col-auto text-right">
              <button v-if="showButtonFor('VISITOR_CREATE')" :disabled="isDisabledFor('VISITOR_CREATE')"
                      :title="buttonTooltip('VISITOR_CREATE')" class="btn btn-primary first-button ml-2"
                      data-toggle="modal" href="#create_visitor_modal">
                <i class="fas fa-plus"></i> Book Visitor
              </button>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <ul class="nav nav-tabs menu-tabs">
          <li class="nav-item" v-if="modules.some(module => module === 'visits') && permissions['VISITORS_READ']">
            <router-link class="nav-link" to="/visits">Visitors</router-link>
          </li>
          <li class="nav-item active"
              v-if="modules.some(module => module === 'visitors') && permissions['VISITORS_READ']">
            <router-link class="nav-link" to="/visitors">Visitors</router-link>
          </li>
          <li class="nav-item" v-if="modules.some(module => module === 'contractors') && permissions['VISITORS_READ']">
            <router-link class="nav-link" to="/contractors">Contractors</router-link>
          </li>
        </ul>

        <!-- Search Filter -->
        <div v-if="showFilters" class="card filter-card" id="filter-inputs">
          <div class="card-body pb-0">
            <form>
              <div class="row filter-row">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Name</label>
                    <input class="form-control" type="text" v-model="filters.name">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Email</label>
                    <input class="form-control" type="text" v-model="filters.email">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Phone</label>
                    <input class="form-control" type="text" v-model="filters.phone">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <button class="btn btn-primary btn-block" type="button" @click="retrieveVisitors">Search</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- /Search Filter -->

        <div ref="visitorsContainer" class="row vld-parent">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row" v-if="permissions && permissions['VISITORS_SEARCH']">
                  <div class="col-sm-12 col-md-0">
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <select
                          class="input-group-text form-control bg-primary"
                          v-model="selectedSearchFilterId"
                          @change="changeSearchFilter"
                          :required="true">
                          <option
                            v-for="searchFilter in searchFilters"
                            :key="searchFilter"
                            :value="searchFilter"
                            :name="searchFilter"
                            :selected="searchFilter">
                            {{ searchFilter }}
                          </option>
                        </select>
                      </div>
                      <input class="form-control" type="text" v-model="searchValue"
                             @keyup="searchVisitors($event)" placeholder="Search visitors...">
                    </div>
                  </div>
                </div>
                <hr/>
                <div class="table-responsive">
                  <table id="tblVisitors" class="table table-hover table-center mb-0"
                         :class="windowWidth < 768 ? 'cards' : '-' ">
                    <thead style="background-color: ghostwhite">
                    <tr class="text-center">
                      <th scope="col" class="text-left">Code</th>
                      <th scope="col" class="text-left">Name</th>
                      <th scope="col" class="text-left">Email</th>
                      <th scope="col" class="text-left">Phone</th>
                      <th scope="col" class="text-left">ID No.</th>
                      <th scope="col"
                          :class="{'text-left': !hasEditOrDeletePermission && isDesktopView, 'text-left': hasEditOrDeletePermission || !isDesktopView}">
                        Status
                      </th>
                      <th class="text-right" v-if="hasEditOrDeletePermission || displayDisabledButtons">Action</th>
                      <th scope="col" class="text-right" v-if="!hasEditOrDeletePermission && !displayDisabledButtons"></th>
                    </tr>
                    </thead>
                    <tbody v-if="visitors.length">
                    <tr class="text-center clickable-row" v-for="visitor in visitors" :key="visitor.id" @click="viewVisitor(visitor.id)">
                      <td col="Code: " class="text-left">{{ visitor.code ? visitor.code : '-' }}</td>
                      <td col="Name: " class="text-left">{{ visitor.name ? visitor.name : '-' }}</td>
                      <td col="Email: " class="text-left">{{ visitor.email ? visitor.email : '-' }}</td>
                      <td col="Phone: " class="text-left">{{ visitor.phone ? visitor.phone : '-' }}</td>
                      <td col="ID No.: " class="text-left">{{ visitor.idNumber ? visitor.idNumber : '-' }}</td>
                      <td col="Status: "
                          :class="{'text-left': !hasEditOrDeletePermission && isDesktopView, 'text-left': hasEditOrDeletePermission || !isDesktopView}">
                        {{ visitor.status }}
                      </td>
                      <td class="text-right btn-block" v-if="hasEditOrDeletePermission || displayDisabledButtons">
                        <a class="btn btn-success" id="showEditVisitorModal" data-toggle="modal"
                           href="#edit_visitor_modal" hidden></a>
                        <a class="btn btn-success" id="showAssociateCustomerModal" data-toggle="modal"
                           href="#associate_customer_modal" hidden></a>
                        <button v-if="showButtonFor('VISITOR_UPDATE')" :disabled="isDisabledFor('VISITOR_UPDATE')"
                                :title="buttonTooltip('VISITOR_UPDATE')" @click.stop="editVisitor(visitor.id)"
                                class="btn btn-sm bg-info-light" v-bind:class="windowWidth < 768 ? 'btn-block' : ''">
                          <i class="fa fa-edit mr-1"></i> Edit
                        </button>
                        <a style="display: none" @click.stop="viewVisitor(visitor.id)" class="btn btn-sm bg-success-light"
                           v-bind:class="windowWidth < 768 ? 'btn-block' : ''">
                          <i class="fa fa-eye mr-1"></i> View
                        </a>
                        <a style="display: none" @click.stop="associateCustomer(visitor.id)"
                           class="btn btn-sm bg-purple-light" v-bind:class="windowWidth < 768 ? 'btn-block' : ''">
                          <i class="fa fa-link mr-1"></i> Add
                        </a>
                        <button v-if="showButtonFor('VISITOR_DELETE')" :disabled="isDisabledFor('VISITOR_DELETE')"
                                :title="buttonTooltip('VISITOR_DELETE')" @click.stop="deleteVisitor(visitor.id)"
                                class="btn btn-sm bg-danger-light" v-bind:class="windowWidth < 768 ? 'btn-block' : ''">
                          <i class="fa fa-trash mr-1"></i> Delete
                        </button>
                      </td>
                      <td class="text-right" v-if="!hasEditOrDeletePermission && !displayDisabledButtons">
                        <i class="fas fa-chevron-right text-muted"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="!visitors.length" class="text-center mt-5 mb-5">
                  <div>You don't have any visitors yet</div>
                </div>
                <div v-if="visitors.length" class="row">
                  <div class="col-sm-12 col-md-5">
                    <div class="" id="tblProducts_info" visitor="status" aria-live="polite" style="padding-top: 1.25em">
                      Show
                      <select @change="onChangeRecordsPerPage" v-model="recordsPerPage">
                        <option :value="5">5</option>
                        <option :value="10">10</option>
                        <option :value="20">20</option>
                        <option :value="30">30</option>
                        <option :value="40">40</option>
                        <option :value="50">50</option>
                      </select>
                      of {{ totalRecords }} entries
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-7">
                    <div class="dataTables_paginate paging_simple_numbers" id="tblProducts_paginate"
                         style="padding-top: 0.55em">
                      <pagination
                        :totalPages="totalPages"
                        :perPage="recordsPerPage"
                        :currentPage="currentPage"
                        @pagechanged="onPageChange"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Create Visitor Modal -->
        <div class="modal fade" id="create_visitor_modal" aria-hidden="true" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Create {{ $t("sidebar.visitor") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <CreateVisitorForm/>
              </div>
            </div>
          </div>
        </div>
        <!-- Create Visitor Modal -->

        <!-- Create Visitor Modal -->
        <div class="modal fade" id="associate_customer_modal" aria-hidden="true" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Add {{ $t("sidebar.customer") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <AssociateCustomer :cus-id="visitorId"/>
              </div>
            </div>
          </div>
        </div>
        <!-- Create Visitor Modal -->

        <!-- Edit Visitor Modal -->
        <div class="modal fade" id="edit_visitor_modal" aria-hidden="true" role="dialog" ref="modal">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Create {{ $t("sidebar.visitor") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form action="">
                  <div>
                    <div class="form-group">
                      <label>{{ $t("sidebar.visitor") }} Number</label>
                      <input readonly type="text" class="form-control" v-model="visitor.code" ref="visitorNumber"
                             placeholder="">
                    </div>
                    <div class="form-group">
                      <label>First Name</label>
                      <input type="text" class="form-control" v-model="visitor.firstName">
                    </div>
                    <div class="form-group">
                      <label>Last Name</label>
                      <input type="text" class="form-control" v-model="visitor.lastName">
                    </div>
                    <div class="form-group">
                      <label>ID No.</label>
                      <input type="text" class="form-control" v-model="visitor.idNumber">
                    </div>
                    <div class="form-group">
                      <label>Email</label>
                      <input type="text" class="form-control" v-model="visitor.email" readonly>
                    </div>
                    <div class="form-group">
                      <label>Phone</label>
                      <input type="text" class="form-control" v-model="visitor.phone">
                    </div>
                    <div class="form-group">
                      <label>Address</label>
                      <input type="text" class="form-control" v-model="visitor.address">
                    </div>
                    <div class="mt-4">
                      <button class="btn btn-primary btn-block" @click="updateVisitor($event)">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Edit Visitor Modal -->
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import * as visitorService from "../../service/visitor.service";
import Pagination from "../Pagination";
import {allowedModules} from "../../utils/modules";
import {getConfig} from "../../utils/config";
import permissionService from "../../service/permission.service";

export default {
  name: "visitors",
  components: {
    Pagination,
    // CreateVisitorForm,
    // EditVisitorForm,
  },
  data() {
    return {
      visitorId: null,
      visitor: {},
      visitors: [],
      modules: [],
      currentIndex: -1,
      title: "",
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 10,
      showFilters: false,
      filters: {
        name: null,
        email: null,
        phone: null
      },
      searchValue: "",
      searchFilters: ["Number", "Name", "Email", "Phone"],
      selectedSearchFilterId: "Number",
      permissions: [],
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
      fullPage: false,
      pagePermissions: ['VISITOR_CREATE', 'VISITOR_READ', 'VISITOR_UPDATE', 'VISITOR_DELETE', 'VISITORS_SEARCH', 'VISITORS_READ'],
      displayDisabledButtons: !getConfig().hideIfNoPermission
    };
  },
  methods: {
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    changeSearchFilter() {
      this.searchVisitors(null)
    },
    viewVisitor(id) {
      this.$router.push(`/visitors/${id}`);
    },
    editVisitor(id) {
      this.visitorId = id
      this.retrieveVisitor(id)
      document.getElementById('showEditVisitorModal').click()
    },
    associateCustomer(id) {
      this.visitorId = id
      this.retrieveVisitor(id)
      document.getElementById('showAssociateCustomerModal').click()
    },
    retrieveVisitor(id) {
      visitorService.findById(localStorage.getItem('mid'), id)
        .then(response => {
          this.visitor = response.data.data;
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', 'Oops', "Error occurred")
        });
    },
    retrieveVisitors() {
      let loader = this.$loading.show({
        container: this.$refs.visitorsContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      let params = {
        merchantId: localStorage.getItem("mid"),
        firstName: this.filters.firstName,
        lastName: this.filters.lastName,
        email: this.filters.email,
        phone: this.filters.phone,
        page: this.currentPage,
        size: this.recordsPerPage,
        types: 'VISITOR'
      }
      visitorService.findByVendorId(localStorage.getItem("mid"), params)
        .then(response => {
          this.visitors = response.data.data.sort((a, b) => (a.name > b.name) ? 1 : -1)
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          console.log('Error:', e)
          if (e.response && (e.response.status === 401 || e.response.status === 403 || e.response.status === 409)) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          loader.hide()
        });
    },
    searchVisitors(e) {
      e ? e.preventDefault() : null
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.visitorsContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      let params = {
        page: this.currentPage,
        size: this.recordsPerPage,
        types: 'VISITOR',
        op: 'like'
      }
      params[this.selectedSearchFilterId.toLowerCase()] = this.searchValue;
      visitorService.findVisitors(localStorage.getItem("mid"), params)
        .then(response => {
          this.visitors = response.data.data;
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          loader.hide()
        })
    },
    updateVisitor(e) {
      e.preventDefault();
      let visitor = {
        firstName: this.visitor.firstName,
        lastName: this.visitor.lastName,
        idNumber: this.visitor.idNumber,
        phone: this.visitor.phone,
        email: this.visitor.email,
        address: this.visitor.address,
        status: "ACTIVE",
      };
      visitorService.update(localStorage.getItem('mid'), this.visitorId, visitor)
        .then(response => {
          this.visitor = response.data.data;
          document.getElementById('showEditVisitorModal').click()
          this.retrieveVisitors()
          Swal.fire({
            icon: 'success',
            title: 'Done',
            text: "Successfully updated",
            footer: '<a href="">Why do I have this issue?</a>'
          })
        })
        .catch(e => {
          if (e.response.status === 400) {
            Swal.fire({
              icon: 'warning',
              title: 'Failed',
              text: e.response.data.description,
              footer: '<a href="">Why do I have this issue?</a>'
            })
            return
          }
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Oops", "Error occurred")
        });
    },
    deleteVisitor(visitorId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          visitorService.deleteVisitor(localStorage.getItem('mid'), visitorId)
            .then(response => {
              this.success = true;
              this.retrieveVisitors()
              Swal.fire({
                icon: 'success',
                title: 'Done',
                text: "Successfully deleted!",
                footer: '<a href="">Why do I have this issue?</a>'
              })
            })
            .catch(e => {
              if (e.response.status === 400) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Failed',
                  text: e.response.data.description,
                  footer: '<a href="">Why do I have this issue?</a>'
                })
                return
              }
              console.log(e);
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              this.fireNotification('error', "Error occurred", 5000)
            });
        }
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.retrieveVisitors()
    },
    onChangeRecordsPerPage() {
      this.retrieveVisitors()
    },
    fireNotification(icon, message, timeout) {
      Swal.fire({
        toast: true,
        width: 300,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: timeout,
        timerProgressBar: true,
      })
    },
    showButtonFor(permission) {
      if (this.permissions[permission]) {
        return true
      } else {
        return this.displayDisabledButtons
      }
    },
    isDisabledFor(permission) {
      return !this.permissions[permission]
    },
    buttonTooltip(permission) {
      return this.isDisabledFor(permission) ? 'You do not have access to this feature' : ''
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },
    basedOnWindowWidth() {
      if (windowWidth > 768) {
        return true
      }
      return false
    },
    hasEditOrDeletePermission() {
      return this.permissions['VISITOR_UPDATE'] || this.permissions['VISITOR_DELETE']
    }
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 768) {
        return this.isMobileView = true
      } else if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        return this.isTabletView = true
      } else {
        return this.isDesktopView = true
      }
    }
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login')
      return
    }
    const result = await permissionService.checkPermissions(this.pagePermissions)

    if (!result.success) {
      console.error('Error during permission check', result.error)
      await Swal.fire({
        icon: 'warning',
        title: 'Failed',
        text: 'Error during permission check',
        footer: '<a href="">Why do l have this issue</a>'
      })
    }
    this.permissions = result.data
    this.modules = allowedModules.filter(module => module.name === this.$i18n.locale)[0].modules;
    this.retrieveVisitors();
  }
}
</script>
<style scoped>
:disabled {
  cursor: not-allowed
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #f8f9fa;
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/visitors/VisitorList.vue